<div class="grid-container">
    <div class="table-responsive">
        <table class="grid-table table table-bordered">
            <thead>
                <tr>
                    <th [attr.colspan]="to.headers.length" class="grid-header">
                        {{ to.label }}{{ to.label && to.required ? "*" : "" }}
                    </th>
                </tr>
                <tr>
                    <th *ngFor="let header of to.headers" class="grid-header" [style.width]="header.width + '%'">
                        {{ header.label }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of to.rows; let rowIndex = index" class="grid-row">
                    <td *ngFor="let cell of row.columns; let colIndex = index" class="grid-cell" [style.width]="to.headers[colIndex].width + '%'">
                        <ng-container [ngSwitch]="cell.type">
                            <ng-container *ngSwitchCase="'Note'">
                                <label [disabled]="to.rows[rowIndex].columns[colIndex].disabled">
                                    {{ cell.label }}
                                </label>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Number'">
                                <input [disabled]="to.rows[rowIndex].columns[colIndex].disabled"
                                       class="form-control text-right"
                                       type="number"
                                       [ngModel]="getModelValue(cell, rowIndex, colIndex)"
                                       (ngModelChange)="setModelValue(cell, rowIndex, colIndex, $event)"
                                       (keyup.enter)="preventDefault($event)"
                                       (keydown.enter)="preventDefault($event)"
                                       (keyup.arrowup)="preventDefault($event)"
                                       (keydown.arrowup)="preventDefault($event)"
                                       (keyup.arrowdown)="preventDefault($event)"
                                       (keydown.arrowdown)="preventDefault($event)"
                                       onwheel="return false;"
                                       pInputText />
                            </ng-container>
                            <ng-container *ngSwitchCase="'Text'">
                                <input [disabled]="to.rows[rowIndex].columns[colIndex].disabled"
                                       [ngModel]="getModelValue(cell, rowIndex, colIndex)"
                                       (ngModelChange)="setModelValue(cell, rowIndex, colIndex, $event)"
                                       class="form-control"
                                       (keyup.enter)="preventDefault($event)"
                                       (keydown.enter)="preventDefault($event)"
                                       pInputText />
                            </ng-container>
                            <ng-container *ngSwitchCase="'Long'">
                                <textarea [disabled]="to.rows[rowIndex].columns[colIndex].disabled"
                                          [ngModel]="getModelValue(cell, rowIndex, colIndex)"
                                          (ngModelChange)="setModelValue(cell, rowIndex, colIndex, $event)"
                                          style="height: 32px"
                                          class="form-control"
                                          pInputTextarea
                                          autoResize="true"
                                          rows="1"
                                          cols="30"></textarea>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Date'">
                                <p-calendar [disabled]="to.rows[rowIndex].columns[colIndex].disabled"
                                            [selectOtherMonths]="true"
                                            panelStyleClass="table-calendar-mobile modal-calender"
                                            [todayButtonStyleClass]="'p-calender-today-button'"
                                            [clearButtonStyleClass]="'p-calender-clear-button'"
                                            showIcon="true"
                                            placeholder="yyyy-mm-dd"
                                            [styleClass]="'form-control full-width'"
                                            appendTo="body"
                                            [yearRange]="getDefaultYearRange()"
                                            [showButtonBar]="true"
                                            [monthNavigator]="true"
                                            [yearNavigator]="true"
                                            dateFormat="yy-mm-dd"
                                            [keepInvalid]="false"
                                            [minDate]="cell.min"
                                            [maxDate]="cell.max"
                                            [defaultDate]="cell.defaultValue"
                                            [ngModel]="getModelValue(cell, rowIndex, colIndex)"
                                            (ngModelChange)="setModelValue(cell, rowIndex, colIndex, $event)"></p-calendar>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Dropdown'">
                                <p-dropdown [disabled]="to.rows[rowIndex].columns[colIndex].disabled"
                                            [ngModel]="getModelValue(cell, rowIndex, colIndex)"
                                            (ngModelChange)="setModelValue(cell, rowIndex, colIndex, $event)"
                                            [options]="cell.options"
                                            appendTo="body"
                                            [editable]="false"
                                            [styleClass]="'form-control full-width'"
                                            [style]="{ 'display': 'flex', 'min-height': 'calc(1.5em + .75rem + 2px)' }"
                                            [placeholder]="' '"></p-dropdown>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Checkbox'">
                                <p-multiSelect [disabled]="to.rows[rowIndex].columns[colIndex].disabled"
                                               [ngModel]="getModelValue(cell, rowIndex, colIndex)"
                                               (ngModelChange)="setModelValue(cell, rowIndex, colIndex, $event)"
                                               [options]="cell.options"
                                               [appendTo]="'body'"
                                               [styleClass]="'form-control full-width forms-multiselect'"
                                               [resetFilterOnHide]="true"
                                               [autofocusFilter]="false"
                                               [showClear]="false"
                                               [style]="{ 'white-space': 'pre-wrap', 'width': to.headers[colIndex].width + 'px', 'display': 'flex', 'min-height': 'calc(1.5em + .75rem + 2px)' }"></p-multiSelect>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Tickbox'">
                                <p-checkbox [disabled]="to.disabled"
                                            [binary]="true"
                                            [ngModel]="getModelValue(cell, rowIndex, colIndex)"
                                            (ngModelChange)="setModelValue(cell, rowIndex, colIndex, $event)"
                                            class="centered-tickbox"></p-checkbox>
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td *ngFor="let header of to.headers; let colIndex = index" [style.width]="header.width + '%'">
                        <span *ngIf="header.displaySumOfColumn">
                            <label *ngIf="header.sumOfColumnLabel">
                                {{ header.sumOfColumnLabel }}
                            </label>
                            <label class="float-right">
                                {{ calculateColumnSum(colIndex) | number:'1.0-2' }}
                            </label>
                        </span>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
<div *ngIf="to && to.note" class="col-12">
    <sub [innerHTML]="to.note"></sub>
</div>
<div class="clearfix"></div>
